import React, { useContext, useRef, useState } from "react";
import { GlobalContext } from "../../context/hoa-global-context";
import { Button, InputAdornment, TextField } from "@mui/material";
import { FilterList, Search } from "@mui/icons-material";
import PendingSourceAdvanceFiltering from "./AdvanceFiltering";

const PendingSourceFiltering = (props: any) => {
    const { title, subTitle, onAddClick, tagType, orgName, toggleUploadModal } = props;
    const { pendingSource, updatePendingSource } = useContext<any>(GlobalContext);

    const buttonRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [options, setOptions] = useState(pendingSource.options);

    const onChangeText = (event: any) => {
        if (event?.date) {
            setOptions({
                ...options,
                [event.date.key]: new Date(event.date.value).toLocaleString("en-US"),
            });
        } else if (event?.select) {
            setOptions({
                ...options,
                [event.select.key]: event.select.value,
            });
        } else {
            setOptions({
                ...options,
                [event.target.name]: event.target.value,
            });
        }
    };

    const onFilterKeyPress = (event: any) => {
        if (event.keyCode == 13) {
            updateData(options);
        }
    };

    const onMoreFilterClick = (status: string) => {
        const values: any = pendingSource.options;
        const prevValueChanged = !Object.keys(options).every((key) => values[key] === options[key]);
        const clearAll = Object.keys(values).filter((key) => {
            if (values[key]) {
                return key;
            }
        });

        if (status === "Apply" && prevValueChanged) {
            updateData(options);
        } else if (status === "Clear") {
            if (clearAll.length !== 0) {
                const tmpValues: any = options;
                Object.keys(tmpValues).map((key) => {
                    tmpValues[key] = null;
                });
                updateData(tmpValues);
            } else {
                setOptions({});
            }
        } else if (status === "Cancel") {
            const tmpValues: any = options;
            Object.keys(tmpValues).map((key) => {
                if (!values[key]) {
                    tmpValues[key] = null;
                }
            });
            setOptions(tmpValues);
        }

        setAnchorEl(null);
    };

    const updateData = (options: any) => {
        if (new Date(options.from) > new Date(options.to)) {
            alert(`Invalid date range!!!`);
            return;
        }
        if (tagType === "PendingSource") {
            updatePendingSource({
                ...pendingSource,
                data: [],
                pageNumber: 1,
                options: options,
                isLastPage: false,
                fetchingFilteredData: true,
            });
        }
    };

    const handleFilterClick = () => {
        setAnchorEl(buttonRef.current);
    };

    return (
        <>
            <main className="filtering-main-container">
                <div className="filtering-sub-container">
                    <div className="filtering-container left">
                        <span className="filtering-left-container-title">{title}</span>
                        <span className="filtering-left-container-subtitle">{subTitle}</span>
                        <span className="filtering-left-container-subtitle">
                            Total Count: {pendingSource.count ? pendingSource.count : "N/A"}
                        </span>
                    </div>
                    <div className="filtering-container right">
                        <div style={{ marginRight: "16px" }}>
                            <TextField
                                variant="outlined"
                                placeholder={"Search by Sent To/Sent From"}
                                onChange={onChangeText}
                                onKeyDown={onFilterKeyPress}
                                value={options["searchKeyword"]}
                                name={"searchKeyword"}
                                style={{ boxSizing: "border-box" }}
                                sx={{
                                    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                                        {
                                            borderColor: "#E8E8E8",
                                        },
                                    "& .MuiInputBase-root.Mui-focused fieldset": {
                                        borderColor: "#E8E8E8",
                                    },
                                    "& .MuiOutlinedInput-adornedEnd": {
                                        paddingRight: "0px",
                                    },
                                }}
                                InputProps={{
                                    margin: "none",
                                    className: "searchInputClass",
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search style={{ color: "#9F9F9F" }} />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <Button
                                            id="end-filtering-icon-title"
                                            ref={buttonRef}
                                            onClick={handleFilterClick}
                                            style={{
                                                minWidth: "98px",
                                                height: "100%",
                                                padding: "0px",
                                                textTransform: "capitalize",
                                            }}
                                            startIcon={<FilterList style={{ color: "#9F9F9F" }} />}
                                        >
                                            Filter
                                        </Button>
                                    ),
                                }}
                                type={"search"}
                            />
                        </div>
                    </div>
                </div>
            </main>

            {/* Apply Advance filtering options */}
            <PendingSourceAdvanceFiltering
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                onChangeText={onChangeText}
                onMoreFilterClick={onMoreFilterClick}
                options={options}
                tagType={tagType}
            />
        </>
    );
};

export default PendingSourceFiltering;
